import {
	IPartner,
	IPartnerInfoKeysList,
	IPartnerInfoItemList,
} from '../models';

export function mapToPartnerLimitationList<T extends Record<string, number>>(
	infoKeys: IPartnerInfoKeysList,
	partner?: IPartner,
): IPartnerInfoItemList {
	return infoKeys.map(({ total, used, title = '' }) => ({
		title,
		total: partner ? partner[total] : NaN,
		used: partner ? partner[used] : NaN,
	}));
}
